import { router } from '@inertiajs/react';
import { RotateCcw } from 'lucide-react';
import { useState } from 'react';
import { toast } from '@/components/toast';
import { Button } from '@/components/ui/button';
import type { SharedProps } from '@/types';

export function ResendEmailButton({ emailId }: { emailId: string }) {
  const [isPending, setIsPending] = useState(false);

  const handleResendEmail = () => {
    setIsPending(true);
    router.post(
      `/emails/${emailId}/resend`,
      {},
      {
        preserveScroll: true,
        onSuccess: (page) => {
          const { flash } = page.props as unknown as SharedProps;
          toast(
            flash.alert
              ? { type: 'error', description: flash.alert }
              : {
                  type: 'success',
                  description: flash.notice ?? 'Email resent successfully!',
                },
          );
        },
        onError: () =>
          toast({
            type: 'error',
            description:
              'An unexpected error occurred while resending the email',
          }),
        onFinish: () => setIsPending(false),
      },
    );
  };

  return (
    <Button
      onClick={handleResendEmail}
      disabled={isPending}
      variant="outline"
      size="sm"
    >
      <RotateCcw className="mr-2 h-4 w-4" />
      {isPending ? 'Resending...' : 'Resend Email'}
    </Button>
  );
}
